webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_landing_Landing__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_landing_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_landing_Landing__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var title = ' | Young Forever - mobilny gabinet kosmetyczny';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_landing_Landing___default.a,
    meta: {
      title: 'Plasma IQ, Lifting bezinwazyjny ' + title
    }
  }]
}));

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(40),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_js_bootstrap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_js_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_js_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_parallax_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(4);









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_parallax_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavbar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_MainContent__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_MainContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_MainContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_MainFooter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_MainFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_MainFooter__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    MainNavbar: __WEBPACK_IMPORTED_MODULE_0__components_layout_MainNavbar___default.a,
    MainContent: __WEBPACK_IMPORTED_MODULE_1__components_layout_MainContent___default.a,
    MainFooter: __WEBPACK_IMPORTED_MODULE_2__components_layout_MainFooter___default.a
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-content',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-footer',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-navbar',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Intro__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Offer__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Offer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Offer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Plasma__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Plasma___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Plasma__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    Intro: __WEBPACK_IMPORTED_MODULE_0__components_Intro___default.a,
    Offer: __WEBPACK_IMPORTED_MODULE_1__components_Offer___default.a,
    Plasma: __WEBPACK_IMPORTED_MODULE_2__components_Plasma___default.a
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionLeft__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SectionLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionRight__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SectionRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferButton__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OfferButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OfferButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  components: {
    SectionLeft: __WEBPACK_IMPORTED_MODULE_0__SectionLeft___default.a,
    SectionRight: __WEBPACK_IMPORTED_MODULE_1__SectionRight___default.a,
    OfferButton: __WEBPACK_IMPORTED_MODULE_2__OfferButton___default.a
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'offer'
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'offer-button'
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plasma'
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-left'
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-right'
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(42),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c001a6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae51c994",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47893f2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(41),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e733669",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e687259",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d0e102a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(29)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(50),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b83dffd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-523478c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(44),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-navbar'), _vm._v(" "), _c('main-content'), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('intro'), _vm._v(" "), _c('offer'), _vm._v(" "), _c('plasma')], 1)
},staticRenderFns: []}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing__container"
  }, [_c('div', {
    staticClass: "landing__section"
  }, [_c('div', {
    staticClass: "landing__section-container"
  }, [_c('div', {
    staticClass: "landing__section-row"
  }, [_c('div', {
    staticClass: "landing__section-col-left"
  }, [_c('section-left')], 1), _vm._v(" "), _c('div', {
    staticClass: "landing__section-col-right"
  }, [_c('section-right')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "landing__section-row"
  }, [_c('div', {
    staticClass: "landing__section-col"
  }, [_c('offer-button')], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/T3NCz_IVgv4?ecver=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Zabieg z zastosowaniem urządzenia PlasmaIQ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg dropdown-toggle",
    attrs: {
      "id": "btn-offer",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n    Sprawdź już teraz\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "btn-offer"
    }
  }, [_c('a', {
    staticClass: "dropdown-item text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta indywidualna")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-uppercase",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta biznesowa")])])])
}]}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-inverse bg-primary fixed-top"
  }, [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-dropdown",
      "aria-controls": "navbarsExampleDefault",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand ml-5",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-dropdown"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Strona Główna")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta Indywidualna")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Oferta Biznesowa")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Kontakt")])])])])])
}]}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('h1', {
    staticClass: "main-title display-4"
  }, [_vm._v("Young Forever")]), _vm._v(" "), _c('h2', {
    staticClass: "main-title"
  }, [_vm._v("Katarzyna Bieńkowska")]), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('h3', {
    staticClass: "secondary-title"
  }, [_vm._v("mobilny gabinet kosmetyczny")])])
}]}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text justify-content-center"
  }, [_c('div', {
    staticClass: "col-6 align-self-center"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Wskazania")]), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("bezinwazyjny lifting powiek górnych,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek nad górna wargą, tzw. “zmarszczek palacza”,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek na dolnej powiece,")]), _vm._v(" "), _c('li', [_vm._v("redukcja zmarszczek w kąciku oka tzw. “kurzych łapek”,")]), _vm._v(" "), _c('li', [_vm._v("leczenie wspomagające trądziku oraz usuwanie blizn potrądzikowych,")]), _vm._v(" "), _c('li', [_vm._v("usuwanie brodawek, włókniaków, kępek żółtych oraz plamek rubinowych,")]), _vm._v(" "), _c('li', [_vm._v("leczenie rozstępów oraz blizn pooperacyjnych")])])])])])])
}]}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("stworzył Jakub Bieńkowski © " + _vm._s(_vm.year))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-end"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h3', [_vm._v("Kontakt")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Katarzyna Bieńkowska")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:youngforever.biuro@gmail.com"
    }
  }, [_vm._v("youngforever.biuro@gmail.com")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:+48691729207"
    }
  }, [_vm._v("+48 691 72 92 07")])])])])
}]}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container mt-5"
  }, [_c('h1', [_vm._v("Plasma IQ")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("Plasma IQ jest prostym i bezpiecznym urządzeniem do bezinwazyjnego liftingu powiek, drobnych zmarszczek i innych miejscowych zmian skórnych. Dzięki niewielkiemu łukowi elektrycznemu powstającemu pomiędzy końcówką urządzenia, a skórą generowane są mikrowiązki plazmy, które w kontrolowany sposób doprowadzają do sublimacji naskórka i obkurczenia się skóry. Zabieg wykonywany jest punktowo, dzięki czemu precyzyjnie oddziałuje tylko w miejscu zetknięcia ze skórą nie naruszając otaczających tkanek.")]), _vm._v(" "), _c('hr', {
    staticClass: "separator"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Zabieg liftingu powiek przy wykorzystaniu urządzenia Plasma IQ jest:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', [_vm._v("Plasma IQ to urządzenie, dzięki któremu możemy wykonać bezpieczny i mało inwazyjny zabieg liftingowania powiek i okolicy oczu. Efekty są spektakularne. Doskonale sprawdza się w usuwaniu zmarszczek np.: zmarszczek palacza. Jest urządzeniem bardzo precyzyjnym, dlatego też wykorzystuję je przy drobnych zabiegach dermatochirurgicznych. Zabiegi wykonywane przy użyciu urządzenia Plasma IQ są bezpieczne, mało inwazyjne a efekty widoczne są już po pierwszym zabiegu.")]), _vm._v(" "), _c('footer', [_vm._v("dr Michał Kaniowski — Specjalista dermatolog")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Bezinwazyjny")]), _vm._v(" - polecany dla osób, które nie chcą decydować się na zabieg chirurgiczny (blefaroplastykę powiek),")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Precyzyjny")]), _vm._v(" - mikrowiązka plazmy działa jedynie w obrębie naskórka bez uszkadzania skóry,")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Dający natychmiastowy efekt")]), _vm._v(" - efekty widoczne już po pierwszym zabiegu,")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Bezpieczny")]), _vm._v(" - bezpieczny dla osób z rozrusznikami serca oraz osób, u których zabiegi z zastosowaniem prądu nie są wskazane,")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Komfortowy")]), _vm._v(" - nie wymaga wyłączenia z codziennej aktywności.")])])
}]}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.13be99d86d9862842f13.js